export default {
    SET_INITIAL_DATA: 'SET_INITIAL_DATA',
};
